export interface ShowMeta {
    director: string;
    sm: string;
    asm: string;

    leftLogo?: string;
    rightLogo?: string;
}

export interface AppSettings {
    theme?: 'light' | 'dark';
    [key: string]: unknown;
}

export interface Asset {
    id: string;
    prompt: string;
    svgCode: string;
    source?: string;
    savedAt?: number; // Unix timestamp
}

// ===== Costume & Props Shared Types =====

export interface MediaItem {
    id: string;
    url: string; // Legacy/external fallback URL. Repository-backed media keeps this empty.
    type: 'inspiration' | 'reference' | 'actual';
    caption?: string;
    uploadedBy: string; // userId
    uploadedAt: number; // timestamp
    repositoryFileId?: string;
    repositoryStorageRef?: string;
    fileName?: string;
    mimeType?: string;
}

export interface BudgetInfo {
    estimatedCost?: number;
    actualCost?: number;
    currency: string; // default: 'USD'
    receiptUrls?: string[]; // URLs from Cloud File Repository
}

export interface MaintenanceLog {
    needsRepair: boolean;
    repairNotes: string;
    needsLaundry: boolean;
    maintenanceNotes: string;
    lastMaintenance?: number; // timestamp
}

export interface SourceInfo {
    source: 'stock' | 'rental' | 'borrowed' | 'purchased_new' | 'built';
    vendor?: string;
    rentalReturnDate?: string; // ISO date
}

// ===== Shared Text Artifact Flags =====

export const ACTION_ITEM_FLAG_FIELD = 'isActionItem' as const;

export interface ActionItemFlagPrimitive {
    [ACTION_ITEM_FLAG_FIELD]?: true;
}

// ===== Activity Log Support =====

/**
 * Tracks who last modified an entity for audit logging.
 * Required for Activity Log feature (server-side triggers).
 */
export interface LastModifiedBy {
    userId: string;
    userName: string;
    role: string;
    timestamp: number; // Unix timestamp
}

// ===== Project Budget =====

export interface ProjectBudget {
    id: string;
    projectId: string;
    
    // Overall allocations
    costumesTotalBudget: number;
    propsTotalBudget: number;
    
    // Optional category breakdowns (V1: Planning reference only)
    costumeCategories?: {
        name: string;
        allocatedAmount: number;
    }[];
    
    propsCategories?: {
        name: string;
        allocatedAmount: number;
    }[];
    
    currency: string; // default: 'USD'
    fiscalYear?: string;
    notes?: string;
    
    createdBy: string; // userId
    createdAt: number;
    lastUpdatedBy: string;
    lastUpdatedAt: number;
}













